export default ({children}) => children;
